var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryVariance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.984 7.70588H2.776C2.3492 7.70588 2 8.23529 2 8.88235C2 9.52941 2.3492 10.0588 2.776 10.0588H8.984C9.4108 10.0588 9.76 9.52941 9.76 8.88235C9.76 8.23529 9.4108 7.70588 8.984 7.70588ZM14.9412 3H3.17647C2.52941 3 2 3.52941 2 4.17647C2 4.82353 2.52941 5.35294 3.17647 5.35294H14.9412C15.5882 5.35294 16.1176 4.82353 16.1176 4.17647C16.1176 3.52941 15.5882 3 14.9412 3ZM2.74857 14.7647H6.49143C6.90314 14.7647 7.24 14.2353 7.24 13.5882C7.24 12.9412 6.90314 12.4118 6.49143 12.4118H2.74857C2.33686 12.4118 2 12.9412 2 13.5882C2 14.2353 2.33686 14.7647 2.74857 14.7647Z",
    fill: "#616674"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21C11.685 21 9 18.315 9 15C9 11.685 11.685 9 15 9C18.315 9 21 11.685 21 15C21 18.315 18.315 21 15 21ZM15 10.125C12.3187 10.125 10.125 12.3187 10.125 15C10.125 17.6813 12.3187 19.875 15 19.875C17.6813 19.875 19.875 17.6813 19.875 15C19.875 12.3187 17.6813 10.125 15 10.125ZM14.9998 19.3059C17.3788 19.3059 19.3057 17.379 19.3057 15H10.6939C10.6939 17.379 12.6208 19.3059 14.9998 19.3059Z",
    fill: "#616674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryVariance);
export default __webpack_public_path__ + "static/media/inventory_variance.fec9ec081f8f4e7cf0609e23118805e9.svg";
export { ForwardRef as ReactComponent };